import { render, staticRenderFns } from "./base-input.vue?vue&type=template&id=edefe424"
import script from "./base-input.vue?vue&type=script&lang=js"
export * from "./base-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports